import { Component, OnInit } from '@angular/core';
import { remark } from 'src/app/service/modal/remark';
import { RemarkService } from 'src/app/service/apiservice/remark.service';
import { Globals } from '../../../globals';
import { Router } from '@angular/router';
declare function info_noti(msg:any):any;
@Component({
  selector: 'app-remark',
  templateUrl: './remark.component.html',
  styleUrls: ['./remark.component.css']
})
export class RemarkComponent implements OnInit {

  remarkGrid: remark[] = new Array();

  constructor(private _remarkService:RemarkService,private global:Globals,private router:Router) { }

  ngOnInit() {
    localStorage.setItem("Active Route",this.router.url);
    this.global.afterRefreshPageSetToken();
   this.GetRemark_List();
  }

  GetRemark_List()
  {
    this._remarkService.GetRemarkList()
    .subscribe((response)=>
    {
      Object.assign(this.remarkGrid,response);
    },
    error=>
    {
       info_noti(error);
    })
  }

}
